/**
 * Store 基础类
 * 提供状态序列化、反序列化和持久化的基础功能
 */

import type { IStorage } from '../storage/Storage'

export abstract class BaseStore<T> {
  protected storage: IStorage
  protected storageKey: string

  constructor(storage: IStorage, storageKey: string) {
    this.storage = storage
    this.storageKey = storageKey
  }

  /**
   * 序列化状态为可存储的格式
   */
  abstract serialize(): string

  /**
   * 从存储的数据反序列化状态
   */
  abstract deserialize(data: string): void

  /**
   * 从存储中恢复状态
   */
  hydrate(): void {
    try {
      const data = this.storage.getItem<string>(this.storageKey)
      if (data) {
        this.deserialize(data)
      }
    } catch (error) {
      console.error(`[BaseStore] Failed to hydrate from storage: ${this.storageKey}`, error)
    }
  }

  /**
   * 持久化状态到存储
   */
  persist(): void {
    try {
      const data = this.serialize()
      this.storage.setItem(this.storageKey, data)
    } catch (error) {
      console.error(`[BaseStore] Failed to persist to storage: ${this.storageKey}`, error)
    }
  }

  /**
   * 清除存储的状态
   */
  clear(): void {
    try {
      this.storage.removeItem(this.storageKey)
    } catch (error) {
      console.error(`[BaseStore] Failed to clear storage: ${this.storageKey}`, error)
    }
  }

  /**
   * 获取当前状态
   */
  abstract getState(): T
}
